import React, { Component } from 'react';
import { SignupWidgetHoc } from 'core/hoc';
import Markup from './Markup';

const SidebarSignupWidget = props => (
	<SignupWidgetHoc source="sidebar_widget" {...props}>
		{passedProps => (
			<Markup {...passedProps} />
		)}
	</SignupWidgetHoc>
);

export default SidebarSignupWidget;
